import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "./CSS/PurchaseOrdersAddItem.css";
import {
  Alert,
  Badge,
  Button,
  Col,
  Container,
  ListGroup,
  Modal,
  ModalProps,
  Offcanvas,
  Row,
  Spinner,
} from "react-bootstrap";

import {
  ErrorMessageBody,
  PoItem,
  PurchaseOrder,
  PurchaseOrderItem,
  PurchaseOrderItemWithLisiting,
  Specialty,
  Vendor,
  VendorListing,
} from "../../atomic_components/types";
import ListingsView from "../ListingsAndInventory/ListingsView";

import _ from "lodash";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useAppSelector } from "../../state/hooks";
import ListingNetworkUtil from "../ListingsAndInventory/NetworkUtils/ListingNetworkUtils";

import { Prev } from "react-bootstrap/esm/PageItem";
import DateTimeUtils from "../../utils/DateTimeUtils";
import VendorsNetworkUtil from "../Vendors/NetworkUtils/VendorsNetworkUtil";

import Header from "../Header";
import VendorListingsView from "../Vendors/VendorListingsView";
import VendorsListingSearchBar from "../Vendors/VendorsListingSearchBar";
import { Omit, BsPrefixProps } from "react-bootstrap/esm/helpers";
import PurchaseOrdersVendorListingsView from "./PurchaseOrdersVendorListingsView";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";
import { green } from "@mui/material/colors";
import PurchaseOrderPDF from "./PurchaseOrderPDF";
import PurchaseOrderNetworkUtils from "./NetworkUtils/PurchaseOrderNetworkUtils";
import PurchaseOrdersPublishedItemsView from "./PurchaseOrdersPublishedItemsView";
import PurchaseOrderPDF_v2 from "./PurchaseOrderPDF_v2";
import PurchaseOrderPDF_v3 from "./PurchaseOrderPDF_v3";

interface RouteParams {
  po_id: string;
}

function PurchaseOrderPublished() {
  const userDetailsFromStore = useAppSelector(
    (state) => state.userdetails_store
  );

  const { po_id } = useParams<RouteParams>();

  const [purchaseOrderItemsWithListing, setPurchaseOrderItemsWithListing] =
    useState<PurchaseOrderItemWithLisiting[]>([]);
  const [currentPurchaseOrder, setCurrentPurchaseOrder] =
    useState<PurchaseOrder | null>(null);
  const [modalShow, setModalShow] = useState(false);
  const [modifyPurchaseOrder, setModifyPurchaseOrder] = useState(false);
  const [cancelPurchaseOrder, setCancelPurchaseOrder] = useState(false);
  const [chunkedPoItems, setChunkedPoItems] = useState<
    PurchaseOrderItemWithLisiting[][]
  >([]);
  const [
    filteredPurchaseOrderItemsWithListing,
    setFilteredPurchaseOrderItemsWithListings,
  ] = useState<PurchaseOrderItemWithLisiting[]>([]);

  const [generatePDF, setGeneratePDF] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentVendor, setCurrentVendor] = useState<Vendor>({
    id: 0,
    vendor_name: "",
    vendor_address_line: "",
    vendor_city: "",
    vendor_state: "",
    vendor_postal_code: "",
    vendor_gstin: "",
    vendor_contact_number: "",
    created_by: "",
    modified_by: "",
    created_at: "",
    updated_at: "",
    specialties: [],
  });

  const history = useHistory();
  const location = useLocation();
  const vendorsNetworkUtil = new VendorsNetworkUtil(
    "https://your-api-endpoint.com",
    history,
    location
  );
  const purchaseOrderNetworkUtil = new PurchaseOrderNetworkUtils(
    "https://your-api-endpoint.com",
    history,
    location
  );

  useEffect(() => {
    if (!userDetailsFromStore.authorities.includes("AUTH_ADMIN")) {
      history.push(`/listings/all`);
    }
  }, []);

  useEffect(() => {
    const fetchPurchaseOrderByPOId = async (poId: string) => {
      console.log(poId);
      try {
        const response = await purchaseOrderNetworkUtil.getPurchaseOrderById(
          poId
        );
        console.log(response.data);
        setCurrentPurchaseOrder(response.data);
      } catch (error) {
        console.error(
          "Error in fetching vendor listings by vendor id :",
          error
        );
      }
    };

    fetchPurchaseOrderByPOId(po_id);
  }, [po_id]);

  useEffect(() => {
    const fetchVendorByVendorId = async (vendor_id: string) => {
      try {
        const response = await vendorsNetworkUtil.getVendorByVendorId(
          vendor_id
        );
        console.log(response.data);
        setCurrentVendor(response.data);
      } catch (error) {
        console.error("Error in fetching vendor by vendor_id :", error);
      }
    };

    const getPurchaseOrderItemsWithListingByPurchaseOrderId = async (
      poId: number
    ) => {
      try {
        const response =
          await purchaseOrderNetworkUtil.getPurcahseOrderItemsWithListing(
            poId.toString()
          );

        console.log(response.data);
        setPurchaseOrderItemsWithListing(response.data);
        setFilteredPurchaseOrderItemsWithListings(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(
          "Error in getting purchase order items by poId : ",
          error
        );
        setIsLoading(false);
      }
    };

    if (currentPurchaseOrder) {
      if (
        currentPurchaseOrder.status == "PENDING" ||
        currentPurchaseOrder.status == "MARKED_MODIFICATION"
      ) {
        history.push(`/vendor-purchase-orders/add/addItems/${po_id}`);
      }
      fetchVendorByVendorId(currentPurchaseOrder.vendor_id.toString());
      getPurchaseOrderItemsWithListingByPurchaseOrderId(
        currentPurchaseOrder.po_id
      );
    }
  }, [currentPurchaseOrder]);

  useEffect(() => {
    setChunkedPoItems(chunkArray(purchaseOrderItemsWithListing, 4));
  }, [purchaseOrderItemsWithListing]);

  const chunkArray = (
    array: PurchaseOrderItemWithLisiting[],
    size: number
  ): PurchaseOrderItemWithLisiting[][] => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
      array.slice(index * size, index * size + size)
    );
  };

  const handleSearch = (query: string) => {
    console.log("purchase order item searched ", query);
    if (query.length == 0)
      setFilteredPurchaseOrderItemsWithListings(
        _.cloneDeep(purchaseOrderItemsWithListing)
      );
    else
      setFilteredPurchaseOrderItemsWithListings(
        filterPurchaseOrderItemsWithListings(query)
      );
  };

  const filterPurchaseOrderItemsWithListings = (query: string) => {
    query = query.toLowerCase();
    return purchaseOrderItemsWithListing.filter((poItem) => {
      const skuMatches = poItem.listing.sku_id.toLowerCase().includes(query);

      const opsTagMatches = poItem.listing.ops_tag
        .toLowerCase()
        .includes(query);

      return skuMatches || opsTagMatches;
    });
  };

  const onCardClick = (currentListing: PurchaseOrderItemWithLisiting) => {
    console.log("card clicked: ", currentListing);
    setModalShow(true);
    // setSelectedListing(currentListing);
  };

  const markForModification = async () => {
    try {
      const response = await purchaseOrderNetworkUtil.markPoForModification(
        po_id
      );
      history.push(`/vendor-purchase-orders/add/addItems/${po_id}`);
      console.log(response.data);
    } catch (error) {
      console.error(
        "Error in marking purchase order for modification : ",
        error
      );
      const err = error as AxiosError;
      if (err.response && err.response.data && err.response.status == 400) {
        console.log((err.response.data as ErrorMessageBody).message);
        toast.error((err.response.data as ErrorMessageBody).message, {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
        });
      } else {
        toast.error("Unexpected error", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
        });
      }
    }
  };

  const markForCancellation = async () => {
    try {
      const response = await purchaseOrderNetworkUtil.markPoForCancellation(
        po_id
      );
      setCurrentPurchaseOrder(response.data);
      toast.success("Cancelled PO successfully.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
      });
      setCancelPurchaseOrder(false);
    } catch (error) {
      console.error(
        "Error in marking purchase order for cancellation : ",
        error
      );
      const err = error as AxiosError;
      if (err.response && err.response.data && err.response.status == 400) {
        console.log((err.response.data as ErrorMessageBody).message);
        toast.error((err.response.data as ErrorMessageBody).message, {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
        });
      } else {
        toast.error("Unexpected error", {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
        });
      }
    }
  };

  return (
    <div className="overlay">
      <div className="vendor-details">
        <Header />
        <div className="main-container">
          {purchaseOrderItemsWithListing.length > 0 && currentPurchaseOrder ? (
            <div className="vendor-action-container">
              {currentPurchaseOrder.status != "MARKED_CANCELLED" && (
                <div className="vendor-basics vendors-info-card">
                  <div className="vendors-view-card-title">
                    <h4 className="vendor_id">Purchase Order Actions</h4>
                  </div>

                  <div className="vendor-action-buttons-container">
                    {generatePDF
                      ? currentVendor &&
                        currentPurchaseOrder &&
                        purchaseOrderItemsWithListing.length > 0 && (
                          <div>
                            <PDFDownloadLink
                              document={
                                <PurchaseOrderPDF_v3
                                  chunkedPoItems={chunkedPoItems}
                                  purchaseOrder={currentPurchaseOrder}
                                  vendor={currentVendor}
                                  totalItems={
                                    purchaseOrderItemsWithListing.length
                                  }
                                  totalQuantity={purchaseOrderItemsWithListing.reduce(
                                    (total, poItem) =>
                                      total + poItem.required_quantity,
                                    0
                                  )}
                                />
                              }
                              fileName={currentPurchaseOrder.po_id.toString()}
                            >
                              {({ blob, url, loading, error }) => (
                                <Button
                                  className="vendor-action-button"
                                  disabled={loading}
                                >
                                  {loading
                                    ? "Loading document..."
                                    : "Download Purchase order PDF"}
                                </Button>
                              )}
                            </PDFDownloadLink>
                          </div>
                        )
                      : currentPurchaseOrder.status != "MARKED_COMPLETED" &&
                        currentPurchaseOrder.status != "MARKED_CANCELLED" && (
                          <Button
                            variant="outline-primary"
                            className="vendor-action-button"
                            onClick={() => setGeneratePDF(true)}
                          >
                            Generate Purchase Order PDF
                          </Button>
                        )}

                    {currentPurchaseOrder.status != "MARKED_COMPLETED" &&
                      currentPurchaseOrder.status != "MARKED_CANCELLED" && (
                        <Button
                          variant="outline-primary"
                          className="vendor-action-button"
                          onClick={() => setModifyPurchaseOrder(true)}
                        >
                          Modify Purchase Order
                        </Button>
                      )}
                    {currentPurchaseOrder.status != "MARKED_COMPLETED" &&
                      currentPurchaseOrder.status != "MARKED_CANCELLED" && (
                        <Button
                          variant="outline-primary"
                          className="vendor-action-button"
                          onClick={() => setCancelPurchaseOrder(true)}
                        >
                          Cancel Purchase Order
                        </Button>
                      )}
                    {currentPurchaseOrder.status != "MARKED_COMPLETED" &&
                      currentPurchaseOrder.status != "MARKED_CANCELLED" && (
                        <Button
                          variant="outline-primary"
                          className="vendor-action-button"
                        >
                          Start Receiving Items against this Purchase Order
                        </Button>
                      )}
                  </div>
                </div>
              )}
              {purchaseOrderItemsWithListing.length > 0 && (
                <div className="vendor-basics vendors-info-card">
                  <div className="vendors-view-card-title">
                    <h4 className="vendor_id">
                      Published Purchase Order Details
                    </h4>
                    <div className="vendor-details-button-container"></div>
                  </div>
                  <div className="grid-1-cells">
                    {purchaseOrderItemsWithListing.length != 0 && (
                      <div className="grid-2-cells">
                        <Alert variant="light" className="vendor-info">
                          <div>
                            <b>Total SKUs : </b>{" "}
                            {purchaseOrderItemsWithListing.length.toString()}
                          </div>
                        </Alert>
                        <Alert variant="light" className="vendor-info">
                          <div>
                            <b>Total Quantity : </b>
                            {purchaseOrderItemsWithListing.reduce(
                              (total, poItem) =>
                                total + poItem.required_quantity,
                              0
                            )}
                          </div>
                        </Alert>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {currentPurchaseOrder && (
                <div className="vendor-basics vendors-info-card">
                  <div className="vendors-view-card-title">
                    <h4 className="vendor_id">Purchase Order Details</h4>
                  </div>
                  <div className="grid-1-cells">
                    <div className="grid-item-details-card">
                      <label>PO status</label>
                      {currentPurchaseOrder.status == "PENDING_PUBLISHED" && (
                        <Badge className="mt-2 mr-2 ml-2 mb-2" bg="primary">
                          PUBLISHED
                        </Badge>
                      )}
                      {currentPurchaseOrder.status == "MARKED_CANCELLED" && (
                        <Badge className="mt-2 mr-2 ml-2 mb-2" bg="dark">
                          MARKED CANCELLED
                        </Badge>
                      )}
                      {currentPurchaseOrder.status == "MARKED_COMPLETED" && (
                        <Badge className="mt-2 mr-2 ml-2 mb-2" bg="success">
                          MARKED COMPLETED
                        </Badge>
                      )}
                    </div>
                    <div className="grid-item-details-card">
                      <label>Purchase Order Id</label>
                      <input
                        type="text"
                        name="po_id"
                        value={currentPurchaseOrder.po_id}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Purchase Order Name</label>
                      <input
                        type="text"
                        name="po_name"
                        value={currentPurchaseOrder.po_name}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Expiry Date</label>
                      <input
                        type="text"
                        name="po_expiry_date"
                        value={DateTimeUtils.formatDateTime(
                          currentPurchaseOrder.expected_date
                        )}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Created By</label>
                      <input
                        type="text"
                        name="po_created_by"
                        value={currentPurchaseOrder.created_by}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Date Created</label>
                      <input
                        type="text"
                        name="po_date_created"
                        value={DateTimeUtils.formatDateTime(
                          currentPurchaseOrder.created_at
                        )}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              )}
              {currentPurchaseOrder && currentVendor && (
                <div className="vendor-basics vendors-info-card">
                  <div className="vendors-view-card-title">
                    <h4 className="vendor_id">Vendor Details</h4>
                  </div>
                  <div className="grid-1-cells">
                    <div className="grid-item-details-card">
                      <label>Vendor Id</label>
                      <input
                        type="text"
                        name="vendor_id"
                        value={currentVendor.id}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor Name</label>
                      <input
                        type="text"
                        name="vendor_name"
                        value={currentVendor.vendor_name}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor Address Line</label>
                      <input
                        type="text"
                        name="vendor_address_line"
                        value={currentVendor.vendor_address_line}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor City</label>
                      <input
                        type="text"
                        name="vendor_city"
                        value={currentVendor.vendor_city}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor State</label>
                      <input
                        type="text"
                        name="vendor_state"
                        value={currentVendor.vendor_state}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor Postal Code</label>
                      <input
                        type="text"
                        name="vendor_postal_code"
                        value={currentVendor.vendor_postal_code}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor GSTIN</label>
                      <input
                        type="text"
                        name="vendor_gstin"
                        value={currentVendor.vendor_gstin}
                        disabled={true}
                      />
                    </div>
                    <div className="grid-item-details-card">
                      <label>Vendor Contact Number</label>
                      <input
                        type="text"
                        name="vendor_contact_number"
                        value={currentVendor.vendor_contact_number}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="vendor-action-container"></div>
          )}
          {isLoading ? (
            <div className="vendor-skus-spinner-container">
              {" "}
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="vendor-skus-container">
              {purchaseOrderItemsWithListing.length > 0 &&
                currentPurchaseOrder && (
                  <div className="vendor-listings-search-bar-container">
                    <VendorsListingSearchBar
                      onSearch={handleSearch}
                    ></VendorsListingSearchBar>
                  </div>
                )}

              <div className="listings-container purchase-order-vendor-listings-container">
                <PurchaseOrdersPublishedItemsView
                  publishedListings={filteredPurchaseOrderItemsWithListing}
                  onCardClick={onCardClick}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={modifyPurchaseOrder}
        onHide={() => setModifyPurchaseOrder(false)}
        backdrop="static"
        className="alert-dialog"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Modify Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about modification? Please ensure to inform vendor about
          the updated purchase order.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setModifyPurchaseOrder(false)}
          >
            Close
          </Button>
          <Button variant="primary" onClick={() => markForModification()}>
            Understood
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={cancelPurchaseOrder}
        onHide={() => setCancelPurchaseOrder(false)}
        backdrop="static"
        className="alert-dialog"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to cancel this Purchase Order? Please note that
          purchase orders whose status is "Published" and against which no
          quantities were received can only be marked "Cancelled".
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setCancelPurchaseOrder(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={() => markForCancellation()}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PurchaseOrderPublished;
